import parse from 'html-react-parser';
import Head from 'next/head';
import React from 'react';

import { NEXT_PUBLIC_BEDROCK_STATIC_DOMAIN } from '../../../server/config';
import { processHeadForPreview } from '../../util/headProcessor';

interface LayoutHeadProps {
    head?: string;
    preview?: boolean;
    defaultTitle?: string;
}

const LayoutHead: React.FC<LayoutHeadProps> = ({
    head,
    preview = false,
    defaultTitle,
}) => {
    return (
        <Head>
            {head
                ? parse(processHeadForPreview(head, !!preview))
                : defaultTitle && <title>{defaultTitle}</title>}
            {/* preconnect to bedrock static domain */}
            {NEXT_PUBLIC_BEDROCK_STATIC_DOMAIN && (
                <link
                    rel="preconnect"
                    href={`https://${NEXT_PUBLIC_BEDROCK_STATIC_DOMAIN}`}
                />
            )}
        </Head>
    );
};

export default LayoutHead;
